export const initial = window.location.hash.replace(/^#/, '');

export const to = (state, payload) => {
    return payload;
};

export const hashchanged = to;
